import type { z } from 'zod';
import { nameField } from '@/entities/shared/schemas/name-field';
import { zs } from '@/entities/shared/schemas/zod';

/** One step of a task's checklist. Mirrors …/collections/checklist_step.py. */
export const checklistStepSchema = zs.object({
  text: nameField,
  done: zs.boolean().default(false),
});

export type ChecklistStep = z.infer<typeof checklistStepSchema>;
